import { render, staticRenderFns } from "./RecordReviewPage.vue?vue&type=template&id=d987f36a&scoped=true&lang=pug"
import script from "./RecordReviewPage.vue?vue&type=script&lang=js"
export * from "./RecordReviewPage.vue?vue&type=script&lang=js"
import style0 from "./RecordReviewPage.vue?vue&type=style&index=0&id=d987f36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d987f36a",
  null
  
)

export default component.exports